/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBackslash = createReactComponent("outline", "backslash", "IconBackslash", [["path", { "d": "M7 5l10 14", "key": "svg-0" }]]);

export { IconBackslash as default };
//# sourceMappingURL=IconBackslash.mjs.map
